<template lang="pug">
.property
  .property-image
    img(
			:alt="`${data.Title} floorplan image`",
			:src="data.ImageURL",
			@click="loadDetail(data.DetailUrl)")
  .property-data
    h2.property-title(:style="styles.primary.color") {{ data.Title }}
    h6.property-size {{ data.SqFt }}
    h6.property-price(v-if="data.IsRatesApproved") {{ data.Price }}
      span.help {{ data.PricingText }}
    h6.property-avail(:class="data.Availability.AvStatus") 
      span
      | {{ data.Availability.AvText }}
    a.property-detail(
      :style="styles.primary.color",
			@click="loadDetail(data.DetailUrl)") More Details
</template>


<script>
import {mapActions} from 'vuex'
import Theme from '@/listing-app/mixins/Theme'
export default {
	name: "Property",
  data() {
    return {};
  },
  props: ["data"],
	mixins: [Theme],
  methods: {
		...mapActions(["set"]),
    loadDetail(api) {
			this.set({muta: 'detailApi', data: api})
      this.$router.push('detail')
    }
  }
};
</script>

<style lang="scss" scoped>
.property {
  max-width: calc(100% - 40px);
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 5px $gray;
  transition: all 0.5s ease;
  margin: 0 20px 40px;
  width: 100%;
  @media (min-width: 550px) and (max-width: 923px) {
    max-width: calc(50% - 40px);
    margin: 0 20px 40px;
  }
  @media (min-width: 924px) {
    max-width: calc(33.33% - 40px);
  }
}

.property-image {
  padding: 15px;
  cursor: pointer;
  img {
    max-width: 100%;
    cursor: pointer;
  }
}

.property-data {
  display: flex;
  flex-direction: column;
  padding: 20px;
  background: $offWhite;
  flex: 1;
}

.property-title {
  margin: 0 0 10px;
  font-size: 26px;
  color: var(--color_primary);
}

.property-size,
.property-price {
  margin: 0;
  font-size: 16px;
}

.property-price {
	color: $mediumGray;
	font-family: $fontFamilyHeadings;
	font-weight: 700;
  .help {
		display: block;
    margin-bottom: 15px;
    font-size: 11px;
    line-height: 0.8125;
    text-transform: uppercase;
  }
}

.property-avail {
	position: relative;
  display: flex;
	align-items: center;
  margin: auto 0 15px 0;
  font-size: 16px;
	font-weight: 700;
  span {
    display: block;
    position: relative;
    padding-left: 30px;
		height: 30px;
		width: 30px;
  }
  &.available {
    color: $green;
    span {
      &:before {
        content: "";
        height: 12px;
        width: 6px;
        border-right: 2px solid;
        border-bottom: 2px solid;
        transform: rotate(45deg);
        left: 8px;
        top: -2px;
        bottom: 0;
        margin: auto 0;
        position: absolute;
      }
      &:after {
        height: 22px;
        width: 22px;
        border: 2px solid;
        border-radius: 50%;
        left: 0;
        top: 0;
        bottom: 0;
        margin: auto 0;
        position: absolute;
        content: "";
      }
    }
  }
  &.limitedavailability {
    color: $blue;
    span {
      border: 3px solid currentColor;
      height: 25px;
      width: 25px;
      padding-left: 0;
      border-radius: 50%;
      display: block;
      margin-right: 7px;
      &:before {
        content: "";
        position: absolute;
        height: 8px;
        width: 2px;
        top: 1px;
        left: 0;
        right: 1px;
        bottom: 0;
        border-radius: 1.5px 1.5px 0 0;
        margin: auto;
        display: block;
        background: currentColor;
        transform: translateY(-2px);
      }
      &:after {
        content: "";
        position: absolute;
        width: 6px;
        height: 2px;
        top: 1px;
        left: 0;
        right: 1px;
        bottom: 0;
        margin: auto;
        display: block;
        border-radius: 0 1.5px 1.5px 0;
        background: currentColor;
        transform: rotate(45deg);
        transform-origin: 0% 250%;
      }
    }
  }
  &.waitlist {
		height: 30px;
    color: $orange;
    span {
			margin-right: 5px;
      &:before {
        content: "";
        border-bottom: 26px solid;
        border-left: 15px solid transparent;
        border-right: 15px solid transparent;
        left: 0;
        top: 0;
        bottom: 4px;
        margin: auto 0;
        position: absolute;
      }
      &:after {
        left: 50%;
        top: 0;
        bottom: 0;
				position: absolute;
				font-weight: 900;
        content: "!";
				color: $white;
				transform: translateX(-50%);
				line-height: 30px;
				vertical-align: middle;
        z-index: 2;
				font-size: 17px;
      }
    }
  }
  &.soldout {
    color: $redLight;
    span {
      padding-left: 25px;
      &:before,
      &:after {
        content: "";
        height: 2px;
        width: 20px;
        background: currentColor;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        margin: auto 0;
        transform: rotate(45deg);
      }
      &:after {
        transform: rotate(-45deg);
      }
    }
  }
}

.property-detail {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px;
  border: 1px solid currentColor;
	font-size: 1.125rem;
	font-family: $fontFamilyHeadings;
	font-weight: 700;
  line-height: 1;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  transition: background 0.25s ease;
  cursor: pointer;
  &:hover {
    background: var(--color_primary);
		color: $white !important;
    text-decoration: none;
  }
}
</style>
